import { FC, memo } from 'react'

import { MapProviderProps } from '../../lib/types'

import { useMapYandex } from './useMapYandex'
import { YandexMarker } from './YandexMarker'

/**
 * Внутренний компонент карты (мемоизирован для оптимизации)
 */
const YandexMapContent = memo<{
  ymapsComponents: any
  reactify: any
  location: { center: [number, number]; zoom: number }
  markers: any[]
}>(({ ymapsComponents, reactify, location, markers }) => {
  if (!ymapsComponents || !reactify) {
    return (
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f0f0f0',
          color: '#666',
          fontSize: '14px',
        }}
      >
        Загрузка Yandex Maps...
      </div>
    )
  }

  const { YMap, YMapDefaultSchemeLayer, YMapDefaultFeaturesLayer, YMapMarker } = ymapsComponents

  // ✅ ПРАВИЛЬНО: useDefault на верхнем уровне компонента (не в цикле!)
  const locationDefault = reactify.useDefault(location, [
    location.center[0],
    location.center[1],
    location.zoom,
  ])

  return (
    <YMap location={locationDefault} mode='vector' style={{ width: '100%', height: '100%' }}>
      <YMapDefaultSchemeLayer />
      <YMapDefaultFeaturesLayer />

      {/* ✅ ПРАВИЛЬНО: Каждый маркер - отдельный мемоизированный компонент */}
      {markers.map(marker => (
        <YandexMarker
          key={marker.id}
          YMapMarker={YMapMarker}
          id={marker.id}
          latitude={marker.latitude}
          longitude={marker.longitude}
          options={marker.options}
          reactify={reactify}
        />
      ))}
    </YMap>
  )
})

YandexMapContent.displayName = 'YandexMapContent'

/**
 * Провайдер карты Yandex MapsConfigs.tsx
 * Полностью совместим с MapAPI интерфейсом
 *
 * Адаптирует декларативные React-компоненты Yandex к императивному MapAPI
 */
export const MapYandexProvider: FC<MapProviderProps> = ({ settings, onReady, onError }) => {
  const { isInitialized, ymapsComponents, reactify, markers, location } = useMapYandex(
    settings,
    onReady,
    onError
  )

  console.log('🗺️ [MapYandexProvider] Рендер:', {
    isInitialized,
    hasComponents: !!ymapsComponents,
    hasReactify: !!reactify,
    markersCount: markers.length,
    location,
  })

  return (
    <div style={{ width: '100%', height: '100%', position: 'relative' }}>
      <YandexMapContent
        location={location}
        markers={markers}
        reactify={reactify}
        ymapsComponents={ymapsComponents}
      />
    </div>
  )
}

MapYandexProvider.displayName = 'MapYandexProvider'
